import Home from "./HomePages/Home/Home";

function App() {
  return (
    <Home />
  );
}

export default App;
